// Форматирование российского мобильного номера для полей ввода: «+7 916 123-45-67».
// Правила совпадают с backend/internal/phone.Normalize: ведущие 7 или 8 — это код
// страны или межгород и отбрасываются, дальше 10 цифр национального номера
// (мобильные всегда начинаются с 9). Поэтому «7», «8» или сразу «9» дают «+7…».

/** Приводит ввод к виду «+7 916 123-45-67». Пустая строка остаётся пустой. */
export function formatPhoneRu(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return ''
  const national = (digits[0] === '7' || digits[0] === '8' ? digits.slice(1) : digits).slice(0, 10)
  let out = '+7'
  if (national.length) out += ' ' + national.slice(0, 3)
  if (national.length > 3) out += ' ' + national.slice(3, 6)
  if (national.length > 6) out += '-' + national.slice(6, 8)
  if (national.length > 8) out += '-' + national.slice(8, 10)
  return out
}

/** Национальные цифры без кода страны; полный номер — ровно 10. */
export function phoneNationalDigits(value: string): string {
  const digits = value.replace(/\D/g, '')
  return (digits[0] === '7' || digits[0] === '8' ? digits.slice(1) : digits).slice(0, 10)
}
